import React, { FC } from 'react'
import { UnorderedList, ListProps } from '@chakra-ui/react'

export const ValidationUnorderedList: FC<ListProps> = ({
  children,
  ...listProps
}) => (
  <UnorderedList
    {...listProps}
    display="grid"
    fontSize="sm"
    gridColumnGap={4}
    gridRowGap={2}
    sx={{ listStyle: 'none', padding: 0, margin: 0 }}
  >
    {children}
  </UnorderedList>
)
